export const LEVEL_II_CLEAR_TIME_AND_SALES_FLAG = "level-II/clear-time-and-sales-flag";
export const LEVEL_II_OPEN_TIME_AND_SALES = "level-II/open-time-and-sales";
export const LEVEL_II_COPY_STATE = "level-II/copy-state";
